import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faStore, faCar } from '@fortawesome/free-solid-svg-icons';
import heroImage from '../../images/hero-image-gtr.jpg';
import HowItWorks from './HowItWorks';
import './NewLandingPage.css';

const NewLandingPage = () => {
    return (
        <main className="new-landing">
            <section className="hero-section">
                <div className="container">
                    <div className="hero-wrapper">
                        <div className="hero-content">
                            <h1>Get connected with buyers and sellers tailored perfectly to you!</h1>
                            <Link to="/get-started" className="cta-button">
                                Get Started Now!
                            </Link>
                        </div>
                        <div className="hero-image">
                            <img src={heroImage} alt="Luxury car" />
                        </div>
                    </div>

                    <div className="feature-cards">
                        <div className="feature-card">
                            <FontAwesomeIcon icon={faCar} className="card-icon" />
                            <p>We have verified sellers ready to connect. If we don't have a match right now, we'll help you find one!</p>
                        </div>
                        <div className="feature-card">
                            <FontAwesomeIcon icon={faShoppingCart} className="card-icon" />
                            <p>Our buyers are verified, qualified and looking for exactly what you have to sell.</p>
                        </div>
                    </div>
                </div>
            </section>

            <HowItWorks />

            <section className="welcome-section">
                <div className="container">
                    <div className="welcome-content">
                        <h2>Welcome to your personalized experience.</h2>
                        <p>With a selection of verified buyers and sellers and the right tools to connect we make it easy to find the right match with the right protections in place.</p>
                        <Link to="/buyers" className="start-shopping">
                            Show Me More
                        </Link>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>We are the buying <em>and</em> selling revolution</h2>
                    <div className="benefits-grid">
                        <div className="benefit-card">
                            <h3>Premium Selection</h3>
                            <ul>
                                <li>Verified Sellers</li>
                                <li>Quality Assurance</li>
                                <li>Detailed History Reports</li>
                                <li>No-Haggle Pricing</li>
                            </ul>
                        </div>
                        <div className="benefit-card">
                            <h3>Exceptional Experience</h3>
                            <ul>
                                <li>No-Pressure Experience</li>
                                <li>Personalized Matching</li>
                                <li>Flexible Options</li>
                                <li>148 Dealerships Across the Country</li>
                            </ul>
                        </div>
                    </div>
                    <Link to="/get-started" className="register-cta">
                        Join Now
                    </Link>
                </div>
            </section>
        </main>
    );
};

export default NewLandingPage; 